import React from 'react';
import { Button } from 'react-bootstrap';
import Dialog from './Dialog';
import { withTranslation } from 'react-i18next';

const MessageBox = ({ title, message, onConfirm, onCancel, confirmText, cancelText, t, ...rest }) => {
	const footer = (
		<div>
			{onConfirm && <Button bsStyle='primary' className='small' onClick={onConfirm}>{confirmText ? confirmText : t('Common_Yes')}</Button>}
			<Button className='btn-regular small' onClick={onCancel}>{cancelText ? cancelText : t('Common_No')}</Button>
		</div>
	);
	return <Dialog onHide={onCancel} header={title} body={message} footer={footer} {...rest} />;
};

export default withTranslation()(MessageBox);